import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

export interface ToggleStringIconProp {
  className?: string;
  wrapperClassName?: string;
  value?: string;
  icon: React.ReactNode;
  disabled?: boolean;
  enableString: string;
  disableString: string;
  onClick?: () => void;
  onChange?: (value: string) => void;
}

export function ToggleStringIcon({
  value,
  onChange,
  enableString,
  disableString,
  wrapperClassName = 'relative p-1.5 border rounded border-FFFFFF1F h-7 w-7 flex items-center justify-center',
  disabled = false,
  icon,
  onClick,
}: ToggleStringIconProp) {
  const [highlight, setHighlight] = useState(false);

  useEffect(() => {
    setHighlight(value === enableString);
  }, [enableString, value]);

  return (
    <div
      className={classNames(
        'relative',
        wrapperClassName,
        !disabled
          ? highlight
            ? 'cursor-pointer border-primary bg-primary text-white hover:border-primary hover:text-white hover:bg-primary '
            : 'cursor-pointer border-borderColorMain bg-FFFFFF0A text-textColorBase hover:border-primary hover:text-white hover:bg-primary '
          : 'bg-textColorDisabled border-textColorDisabled text-textColorBase cursor-not-allowed',
      )}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) {
          onClick?.();
          onChange?.(highlight ? disableString : enableString);
        }
      }}
    >
      {icon}
    </div>
  );
}
